import { useSelector } from 'react-redux';

import { isSubscriptionOffering } from 'my-core/online-course-utils';

import CoursePurchaseCheckout from 'my-components/CoursePurchaseCheckout';
import SubscriptionCheckout from 'my-components/SubscriptionCheckout';

import OnlineCoursePurchaseFormCtnr from './OnlineCoursePurchaseFormCtnr';

export default function OnlineCoursePurchaseForm(props) {
  const { onlineCourseId } = props;
  const onlineCourse = useSelector(state => state.onlineCourses.items[onlineCourseId]);

  if (isSubscriptionOffering(onlineCourse)) {
    return <SubscriptionCheckout {...props} />;
  } else if (onlineCourse.purchase_type === 'course_bundle') {
    return <CoursePurchaseCheckout {...props} courseId={onlineCourse.course_id} />;
  }
  return <OnlineCoursePurchaseFormCtnr {...props} />;
}
